import React from "react";
import { Pagination } from "react-bootstrap";
import "./Pagination.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void; 
}

const PaginationComponent: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container d-flex align-items-center justify-content-center mt-4">
      <Pagination>
        <Pagination.First 
          onClick={() => onPageChange(1)} 
          disabled={currentPage === 1} 
        />

        <Pagination.Prev 
          onClick={handlePrevious} 
          disabled={currentPage === 1} 
        />

        <Pagination.Item active>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </Pagination.Item>

        <Pagination.Next 
          onClick={handleNext} 
          disabled={currentPage === totalPages} 
        />

        <Pagination.Last 
          onClick={() => onPageChange(totalPages)} 
          disabled={currentPage === totalPages} 
        />
      </Pagination>
    </div>
  );
};

export default PaginationComponent;
